import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { bibFieldShape } from '@bibliocommons/bc-prop-types';
import cn from 'classnames';

import './FieldLabel.scss';

export default function FieldLabel({ className, field }) {
  return (
    <div className={cn('cp-bib-field-label', className)}>
      <FormattedMessage id={`bib_metadata_field_${field.get('fieldName', '').toLowerCase()}`} />
    </div>
  );
}

FieldLabel.propTypes = {
  className: PropTypes.string,
  field: bibFieldShape
};
